<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="academicLevelSummary && academicLevelProgress">
			<title-bar title="Progreso" :percentage="academicLevelSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="academicLevelSummary.itemName" :percentage="academicLevelSummary.itemPercentage" percentageTitle="Promedio Nivel"/>
			<div class="row between innerRubric">
				<progress-chart v-for="category in progressionReport.coachingCategories" :key="category.id" :categoryId="category.id" :data="category.graphData" :title="category.name" :percentage="category.percentage"/>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['academicLevelId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		academicLevelSummary () {
			if (this.$store.state.academicLevels.summary) return this.$store.state.academicLevels.summary.find((item) => {
				return item.itemId == this.academicLevelId;
			});
			else return this.$store.state.academicLevels.summary;
		},
		academicLevelProgress () {
			if (this.$store.state.academicLevels.progress) return this.$store.state.academicLevels.progress.find((item) => {
				return item.academicLevel.id == this.academicLevelId;
			}).progress;
			else return this.$store.state.academicLevels.progress;
		},
		progressionReport () {
			if (!this.academicLevelProgress) return [];
			this.academicLevelSummary.coachingCategories.forEach((coachingCategory) => {
				coachingCategory.graphData = {
					labels: this.academicLevelProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == coachingCategory.id) result = parseInt(category.percentage);
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.academicLevelProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == coachingCategory.id) result = parseInt(category.percentage);
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.academicLevelProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
			});
			return this.academicLevelSummary;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/academicLevels/CategoriesProgress.vue